"use client"
import { extractData, getServiceCenter, SingleServiceCenterDto } from "api"
import { Desktop, useIsDesktop } from "common/MediaQueries"
import useGeoLocation from "hooks/useGeolocation"
import { useEffect, useState } from "react"
import InnerPageWrapper from "reusable/wrappers/InnerPageWrapper"
import styled from "styled-components"
import ErrorLocationPopUp from "../../../reusable/popups/ErrorLocationPopUp"
import TwoToggleButtons from "../../../reusable/TwoToggleButtons"
import AreSelectionButtons from "../AreSelectionButtons"
import DynamicMap from "../map/DynamicMap"
import { useMapContext } from "../map/MapContext"
import {
  Areas,
  cityFilterList,
  isInHesderFilterList,
  locationFilterListService,
  ToggleButtons,
} from "../map/utils/mapFilters"
import CitySearch from "./CitySearch"
import ServiceCentersList from "./ServiceCentersList"

const StyledContentWrap = styled.div`
  display: flex;
  padding-top: 40px;
  width: 100%;
`

const StyledContentSection = styled.section`
  width: 100%;
  direction: ltr;
  ::-webkit-scrollbar-track {
    background: #d5d5d5;
  }
  ::-webkit-scrollbar-thumb {
    background: #999999;
    height: 80px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 350px;
    flex-shrink: 0;
    height: 680px;
    overflow-y: auto;
  }
`
const StyledMapSection = styled.section`
  flex-grow: 1;
  flex-shrink: 0;
  height: 680px;
  position: sticky;
  transition: top 221ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  align-self: flex-start;
  padding: 0px 25px;
`

const StyledTwoToggleButtons = styled(TwoToggleButtons)`
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 320px;
    margin: 0 auto;
  }
`
const StyledLocationWrap = styled.div`
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 320px;
    margin: 40px auto 0px;
  }
`
const StyledCitySearch = styled(CitySearch)`
  margin-top: 20px;
  label:not(.MuiInputLabel-shrink) {
    transform: translate(-10px, 8px) scale(1);
  }
`
const ServiceCentersPage = () => {
  const {
    setStores,
    setMap,
    setMaps,
    stores,
    setFilterStores,
    setSelectedStore,
    alphabetOrderStores,
    setAlphabetOrderStores,
  } = useMapContext<SingleServiceCenterDto>()
  // toggle states:
  const [toggleIndex, setToggleIndex] = useState(ToggleButtons.CLOSE_TO_ME)
  const [selectedAreaId, setSelectedAreaId] = useState(Areas.ALL)
  // additional filter for cities
  const cities =
    stores
      ?.map((item) => item.city)
      ?.filter((value, i, array) => array.indexOf(value) === i)
      ?.sort((a, b) => a.localeCompare(b)) || []

  const [selectedCity, setSelectedCity] = useState<string>("")
  const [inHesder] = useState<boolean>(false)
  // popup States:
  const [userHasSeenPopUpError, setUserHasSeenPopUpError] = useState(false)
  const [openErrorPopUp, setOpenErrorPopUp] = useState(false)
  // location states:
  const { loaded, error, lng, lat } = useGeoLocation()
  const isDesktop = useIsDesktop()

  // if user allow location and we have coordinates (lat,lng) call the api
  useEffect(() => {
    if (error.code !== "") {
      setToggleIndex(ToggleButtons.AREAS)
    }
    let isComponentMounted = true
    if (error.code != "" && !userHasSeenPopUpError) {
      setOpenErrorPopUp(true)
    }
    const fetchData = async () => {
      if (isComponentMounted) {
        if (loaded && lng && lat) {
          const data = await getServiceCenter(lng, lat).then(extractData)
          const alphabetData = await getServiceCenter(
            null as unknown as number,
            null as unknown as number
          ).then(extractData)
          setAlphabetOrderStores(alphabetData?.body)
          setStores(data?.body)
        }
      }
    }
    fetchData().catch(console.error)
    return () => {
      isComponentMounted = false
    }
  }, [error, loaded, lng, lat])

  // filter the stores:
  useEffect(() => {
    //Filter options updated so apply all filters here

    let result =
      toggleIndex === ToggleButtons.CLOSE_TO_ME ? stores : alphabetOrderStores
    result = locationFilterListService(result, selectedAreaId, toggleIndex)
    result = cityFilterList(result, selectedCity)
    result = isInHesderFilterList(result, inHesder)
    setFilterStores(result)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stores, selectedAreaId, toggleIndex, selectedCity, inHesder])

  return (
    <>
      <InnerPageWrapper
        title="מרכזי השירות של מאזדה"
        subtitle="מרכזי השירות שלנו פרוסים בכל הארץ, זמינים לטפל בכל עניין וללוות אותך לשנים.
        לחיפוש מרכז שירות ולתיאום הגעה, יש לבחור באחת מהאפשרויות"
        imgUrl={
          isDesktop
            ? "/img/cover/Servicecenters.jpg"
            : "/img/cover/Servicecentersmobile.jpg"
        }
        breadCrumbName="ServicesCenters"
      >
        <StyledTwoToggleButtons
          activeButton={toggleIndex}
          setActiveButton={setToggleIndex}
          optionsList={["קרוב אליי", "לפי אזור"]}
          toggleId="map-toggle"
        />

        {toggleIndex === ToggleButtons.AREAS && (
          <StyledLocationWrap>
            <AreSelectionButtons
              activeButton={selectedAreaId}
              setActiveButton={setSelectedAreaId}
              onSelectFunction={() => setSelectedStore(null)}
            />
            <StyledCitySearch
              cities={cities}
              setSelectedCity={setSelectedCity}
            />
          </StyledLocationWrap>
        )}

        <StyledContentWrap>
          <StyledContentSection>
            <ServiceCentersList />
          </StyledContentSection>
          <Desktop>
            <StyledMapSection>
              <DynamicMap setMaps={setMaps} setMap={setMap} />
            </StyledMapSection>
          </Desktop>
        </StyledContentWrap>

        <ErrorLocationPopUp
          open={openErrorPopUp}
          setOpen={setOpenErrorPopUp}
          setUserHasSeenPopUpError={setUserHasSeenPopUpError}
        />
      </InnerPageWrapper>
    </>
  )
}

export default ServiceCentersPage
